import { Sun, Moon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/hooks/useTheme'
import { cn } from '@/lib/utils'

interface ThemeToggleProps {
  variant?: 'icon' | 'labeled'
  className?: string
}

export function ThemeToggle({ variant = 'icon', className }: ThemeToggleProps) {
  const { isDark, toggleTheme } = useTheme()

  const Icon = isDark ? Moon : Sun
  const ariaLabel = isDark ? 'Switch to light theme' : 'Switch to dark theme'

  if (variant === 'labeled') {
    return (
      <Button
        variant="ghost"
        onClick={toggleTheme}
        className={cn('gap-2', className)}
        aria-label={ariaLabel}
      >
        <Icon className="size-4" />
        <span>{isDark ? 'Light mode' : 'Dark mode'}</span>
      </Button>
    )
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={className}
      aria-label={ariaLabel}
    >
      <Icon className="size-4" />
    </Button>
  )
}
